<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="70%" :visible.sync="visible" @close="onCloseDataDia">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="100px">
        <el-form-item label="课程编码" prop="courseCode">
            <el-input v-model="courseCode" placeholder="课程编码"></el-input>
        </el-form-item>
        <el-form-item label="课程名称" prop="courseName">
            <el-input v-model="dataForm.courseName" placeholder="课程阶段名称"></el-input>
        </el-form-item>
        <el-form-item label="所属系列" prop="itemId">
            <el-dict-select placeholder="请选择所属系列" v-model="dataForm.itemId" type="courseItemSelects" :props="{ value: 'id', label: 'itemName' }"></el-dict-select>
        </el-form-item>
        <el-form-item label="所属阶段" prop="stageId">
            <el-dict-select placeholder="请选择所属阶段" v-model="dataForm.stageId" :params="stageDictParams" type="courseStageSelects" :props="{ value: 'id', label: 'stageName' }"></el-dict-select>
        </el-form-item>
        <el-form-item label="课程类型" prop="courseClassType"> 
          <el-select v-model="dataForm.courseClassType" placeholder="请选择课程类型">
            <el-option label="常规课" value="NORMAL"></el-option>
            <el-option label="营队课" value="CAMP"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程绑定旧课名称，不是请忽略" prop="courseOldId" label-width="230px"> 
          <el-dict-select placeholder="课程名称" v-model="dataForm.courseOldId" type="courseSelects" :props="{value: 'id', label: 'courseName'}"></el-dict-select>
        </el-form-item>
        <el-form-item label="封面" prop="cover">
            <cover-upload v-model="dataForm.cover" accept="image/*">
                请上传
                <el-tag size="mini">图片</el-tag>
                文件
            </cover-upload>
        </el-form-item>
        <el-form-item label="上传课件" prop="courseWare">
            <!-- <tx-upload v-model="dataForm.courseWare" accept=".pptx">
                  请上传 <el-tag size="mini">.pptx</el-tag> 文件
                </tx-upload> -->
            <el-input v-model="dataForm.courseWare" placeholder="请输入课件地址"></el-input>
        </el-form-item>
        <el-form-item label="上传新讲义" prop="newHandout">
            <el-input v-model="dataForm.newHandout" placeholder="请输入新讲义地址"></el-input>
        </el-form-item>
        <el-form-item label="课件视频" prop="pptVideo">
            <tx-upload v-model="dataForm.pptVideo" type="more" accept="video/*">
                请上传课件关联视频
            </tx-upload>
        </el-form-item>
        <el-form-item label="外链">
            <div style="margin: 5px 0">
                <el-tag v-for="tag in outSites" :key="tag.value" closable @close="onClickTag(tag.value)" style="margin: 5px">
                    {{ tag.label }}
                </el-tag>
            </div>
            <el-button type="primary" @click="onClickW">添加外链</el-button>
        </el-form-item>
        <el-form-item label="上传讲义" prop="handout">
            <tx-upload v-model="dataForm.handout" accept=".pdf">
                请上传
                <el-tag size="mini">.pdf</el-tag>
                文件
            </tx-upload>
        </el-form-item>
        <el-form-item label="上传说课视频" prop="techVideo">
            <tx-upload v-model="dataForm.techVideo" type="more" accept="video/*">
                请上传视频文件
            </tx-upload>
        </el-form-item>
        <el-form-item label="上传实录视频" prop="recordVideo">
            <tx-upload v-model="dataForm.recordVideo" type="more" accept="video/*">
                请上传视频文件
            </tx-upload>
        </el-form-item>
        <el-form-item label="上传制作视频" prop="makeVideo">
            <tx-upload v-model="dataForm.makeVideo" type="more" accept="video/*">
                请上传视频文件
            </tx-upload>
        </el-form-item>
        <el-form-item label="项目手册" prop="projectManual">
            <tx-upload v-model="dataForm.projectManual" accept=".pdf">
                请上传
                <el-tag size="mini">.pdf</el-tag>
                文件
            </tx-upload>
        </el-form-item>
        <el-form-item label="简介" size="introduction">
            <el-input v-model="dataForm.introduction" type="textarea" placeholder="请输入简介"></el-input>
        </el-form-item>

        <!--   <el-form-item label="上传物料表" prop="materialFile">
              <el-file-upload v-model="dataForm.materialFile" accept=".docx">
                请上传 <el-tag size="mini">.docx</el-tag> 文件
              </el-file-upload>
            </el-form-item>-->
    </el-form>
    <el-dialog title="添加外链" :visible.sync="openW" width="50%" :append-to-body="true" @close="onCloseWDia">
        <el-form :model="wForm" ref="wForm" :rules="wFormRules" label-width="80px">
            <el-form-item label="名称" prop="label">
                <el-input v-model="wForm.label"></el-input>
            </el-form-item>
            <el-form-item label="链接" prop="url">
                <el-input v-model="wForm.url"></el-input>
            </el-form-item>
        </el-form>

        <span slot="footer">
            <el-button @click="onCloseWDia">取消</el-button>
            <el-button type="primary" @click="onClickAddW">添加</el-button>
        </span>
    </el-dialog>
    <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()" :loading="loading">确定</el-button>
    </span>
</el-dialog>
</template>

<script>
/* import {
    aesDecrypt
} from "../../../utils"; */

export default {
    data() {
        return {
            visible: false,
            loading: false,
            courseCode: '',
            dataForm: {
                itemId: '',
                stageId: '',
                courseCode: '',
                courseName: '',
                courseWare: '',
                newHandout: '',
                handout: '',
                techVideo: "",
                recordVideo: "",
                makeVideo: "",
                pptVideo: "",
                introduction: "",
                courseClassType: "",
                courseOldId: "",
                projectManual: undefined
            },
            dataRule: {
                /* courseCode: [
                     {required: true, message: "请输入课程编码", trigger: "change"},
                 ],*/
                courseName: [{
                    required: true,
                    message: "请输入课程名称",
                    trigger: "blur"
                }, ],
                stageId: [{
                    required: true,
                    message: "请选择所属阶段",
                    trigger: "change"
                }, ],
                itemId: [{
                    required: true,
                    message: "请选择所属系列",
                    trigger: "change"
                }, ],
                courseClassType: [{
                    required: true,
                    message: "请选择课程类型",
                    trigger: "change"
                }, ],
            },
            outSites: [],
            openW: false,
            wForm: {
                label: "",
                url: "",
            },
            wFormRules: {
                label: {
                    required: true,
                    trigger: "blur",
                    message: "请输入名称"
                },
                url: {
                    required: true,
                    trigger: "change",
                    message: "请上传文件"
                },
            },
        };
    },
    created() {
        // this.prohibit();
    },
    computed: {
        stageDictParams() {
            return {
                itemId: this.dataForm.itemId
            };
        },
        dictProps() {
            return {
                label: "value",
                value: "code"
            };
        },
        groupStageParams() {
            return {
                type: "StudentStage"
            };
        },
        userStageLevelParams() {
            return {
                type: this.dataForm.userStage
            };
        },
    },
    methods: {
        init(id) {
            this.dataForm.id = id || 0;
            this.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    this.$http({
                        url: this.$http.adornUrl(`/course/course/info/${this.dataForm.id}`),
                        method: "get",
                        params: this.$http.adornParams(),
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            //放开加密限制
                            //let courseStr = aesDecrypt(data.course, "af8a6575c1");
                            let course = JSON.parse(data.course);
                            data.course = course;
                            this.dataForm.id = data.course.id;
                            this.dataForm.courseName = data.course.courseName;
                            this.courseCode = data.course.courseCode;
                            this.dataForm.itemId = data.course.itemId;
                            this.dataForm.stageId = data.course.stageId;
                            this.dataForm.courseWare = data.course.courseWare;
                            this.dataForm.newHandout = data.course.newHandout;
                            this.dataForm.handout = data.course.handout;
                            this.dataForm.cover = data.course.cover;
                            this.dataForm.techVideo = data.course.techVideo;
                            this.dataForm.recordVideo = data.course.recordVideo;
                            this.dataForm.makeVideo = data.course.makeVideo;
                            this.dataForm.pptVideo = data.course.pptVideo;
                            this.dataForm.introduction = data.course.introduction;
                            this.dataForm.projectManual = data.course.projectManual;
                            this.dataForm.courseClassType = data.course.courseClassType;
                            this.dataForm.courseOldId = data.course.courseOldId;
                            if (data.course.outSite) {
                                const arr = data.course.outSite.split(";");
                                arr.forEach((v, i) => {
                                    const [label, url] = v.split("=");
                                    this.outSites.push({
                                        label,
                                        url,
                                        value: i,
                                    });
                                });
                            }

                            this.$nextTick(() => {
                                this.dataForm.stageId = data.course.stageId;
                            });
                        }
                    });
                }
            });
        },
        /*          prohibit() {	// 禁用鼠标右击、F12

                      document.onselectstart = function () { return false; }
                      document.oncontextmenu = function(){
                          return false;
                      }
                      document.onkeydown = function(e) {
                          if (e.ctrlKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 80 || e.keyCode === 83 || e.keyCode === 85  || e.keyCode === 117)) {
                              return false;
                          }
                          if(e.keyCode==18||e.keyCode==123){
                              return false
                          }
                      };
                  },*/
        // 表单提交
        dataFormSubmit() {
            if (this.courseCode === '') {
                this.$message({
                    message: "请输入课程编码",
                    type: "warn",
                })
                return
            }
            this.dataForm.courseCode = this.courseCode;
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    const arr = this.outSites.map((v) => {
                        return `${v.label}=${v.url}`;
                    });
                    const outSite = arr.join(";");
                    this.$http({
                            url: this.$http.adornUrl(
                                `course/course/${!this.dataForm.id ? "save" : "update"}`
                            ),
                            method: `${this.dataForm.id ? "put" : "post"}`,
                            data: this.$http.adornData({
                                ...this.dataForm,
                                outSite
                            }),
                        })
                        .then(({
                            data
                        }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: `${this.dataForm.id ? "更新成功" : "新增成功"}`,
                                    type: "success",
                                });
                                this.visible = false;
                                this.$emit("refreshDataList");
                            } else {
                                this.$message.error(data.msg);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
        handleUpload() {
            this.uploadVisible = true;
            this.$nextTick(() => {
                this.$refs.ossUpload.init();
            });
        },
        onCloseDataDia() {
            this.dataForm = {
                itemId: undefined,
                stageId: undefined,
                courseName: undefined,
                courseWare: undefined,
                newHandout: undefined,
                handout: undefined,
                techVideo: undefined,
                recordVideo: undefined,
                makeVideo: undefined,
                courseOldId: undefined,
                courseClassType: '',
                pptVideo: "",
                introduction: "",
                projectManual: undefined
            };
            this.outSites = [];
            this.$refs.dataForm.resetFields();
        },
        onCloseWDia() {
            this.openW = false;
            this.wForm = {
                label: "",
                url: "",
            };
            this.$refs.wForm.resetFields();
        },
        onClickAddW() {
            this.$refs.wForm.validate((r) => {
                if (r) {
                    this.outSites.push({
                        value: this.outSites.length,
                        ...this.wForm,
                    });
                    this.onCloseWDia();
                }
            });
        },
        onClickW() {
            this.openW = true;
        },
        onClickTag(value) {
            console.log("value", value);
            this.outSites = this.outSites.filter((v) => v.value !== value);
        },
    },
};
</script>
